import { Link } from 'wouter';
import { ROUTES } from '../../routes/consts';
import { Users } from '@platform/client';

// Stub dashboard/experteer/account page; unused
const AccountPanel = () => {
  const user = Users.useGetCurrentUser();
  return (
    user.isSuccess && (
      <div className='text-display-sm px-10'>
        <h1 className='mb-6'>Account & Profile</h1>
        <div className='flex flex-wrap gap-4'>
          <AccountCard
            title='Edit Profile'
            description={`This is your ${user.data.accountType === 'experteer' ? 'professional' : "organization's"} profile`}
            url={`~/platform${ROUTES.EDIT_PROFILE}`}
          />
          {user.data.accountType === 'experteer' && (
            <AccountCard
              title='Preview Your Profile'
              description='View how your profile will appear to organizations'
              url={`~/platform${ROUTES.DIRECTORY}${ROUTES.PROFESSIONALS}/${user.data.userId}`}
            />
          )}
          {user.data.accountType === 'organization' && (
            <AccountCard
              title='Preview Your Profile'
              description='View how your profile will appear to professionals'
              url={`~/platform${ROUTES.DIRECTORY}/organizations/${user.data.organization?.id}`}
            />
          )}
          <AccountCard
            title='Change Your Email'
            description='Use this form to change your email'
            url={`~/platform${ROUTES.UPDATE_YOUR_EMAIL}`}
          />
          <AccountCard
            title='Reset Your Password'
            description='Edit your authentication details'
            url={`~/platform${ROUTES.PROFILE}${ROUTES.CHANGE_PASSWORD}`}
          />
        </div>
        <p className='mt-6 text-sm text-gray-600'>
          No longer want to be a member?{' '}
          <a
            href={'mailto:support@movingworlds.org?subject=Please remove my account'}
            className='hover:underline text-brand-500'
          >
            Request to delete your account.
          </a>
        </p>
      </div>
    )
  );
};

type AccountCardProps = {
  title: string;
  description: string;
  url: string;
};

const AccountCard = (props: AccountCardProps) => {
  return (
    <Link to={props.url}>
      <div className='w-96 h-24 p-3 border shadow transition-transform duration-200 hover:-translate-y-1 hover:shadow-lg'>
        <h2 className='text-xl'>{props.title}</h2>
        <div className='h-0.5 w-1/3 bg-accent-500 my-2' />
        <p className='text-sm text-gray-600'>{props.description}</p>
      </div>
    </Link>
  );
};

export default AccountPanel;
